<!-- 推送服务 -->
<template>
  <div class="shell">
    <div class="descPage ordinaryListPage" v-if="!judeStatus">
      <div class="functionDesc">
        <div class="imgBox"></div>
        <div class="descBox">
          <p class="title">48小时活跃粉丝推送</p>
          <p class="smTitle">利用微信客服消息接口，唤醒粉丝活跃，提高转化</p>
          <ul>
            <li>• 支持推送文本、图文、图片、小程序卡片等消息类型</li>
            <li>• 支持一次推送多条不同类型内容</li>
            <li>• 支持多维度如粉丝标签、性别等推送</li>
          </ul>
          <div
            class="createRightNow"
            @click="$router.push('activeHome?present=0')"
          >
            立即创建
          </div>
        </div>
      </div>

      <!---->
    </div>
    <!-- 有数据的情况展示列表 -->
    <div class="dataList" v-else>
      <div class="tops">
        <div class="topTile">活跃粉丝推送</div>
        <div class="secondTitle">
          <div>
            在不占用公众号推送次数基础上，对48小时内互动过的活跃粉丝发送消息。适用于已认证订阅号或已认证服务号。
          </div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="$router.push('activeHome')"
          >
            立即创建
          </el-button>
        </div>
      </div>
      <div class="list">
        <el-form
          ref="form"
          :model="form"
          label-width="120px"
          label-position="left"
          :inline="true"
        >
          <el-form-item label="发送完成时间">
            <el-date-picker
              v-model="form.data"
              size="small"
              value-format="yyyy-MM-dd"
              format="yyyy 年 MM 月 dd 日"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="initData" size="small" icon="el-icon-search"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
        <el-table :data="listData" max-height="500px" style="width: 99%">
          <el-table-column prop="index" label="编号" width="180">
          </el-table-column>

          <el-table-column prop="createTime" label="发送时间" width="180">
          </el-table-column>
          <el-table-column prop="completeTime" label="发送完成时间" width="180">
          </el-table-column>
          <el-table-column prop="num" label="发送总人数"> </el-table-column>
          <el-table-column prop="is_status" label="发送状态"> </el-table-column>
          <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text">删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <el-pagination
        layout="prev, pager, next, total, jumper"
        :current-page="page"
        :total="total"
        :page-size="10"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { sendList } from "@/api/push";
import time from "@/utils/time";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      total: 0,
      listData: [],
      form: {
        name: "",
        data: ""
      },
      judeStatus: false
    };
  },

  components: {},
  created() {
    console.log("客服消息！！");
    this.initData();
    this.jude();
  },
  methods: {
    handleCurrentChange(p) {
      this.page = p;
      this.initData();
    },
    initData() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      };
      //时间查询
      if (this.form.data.length > 0) {
        data.start_time = this.form.data[0];
        data.end_time = this.form.data[1];
      }
      sendList(data).then(res => {
        if (res.code == 200) {
          this.listData = res.data.data;
          this.total = res.data.total;
          this.page = res.data.last_page;
          this.listData.forEach((item, c_index) => {
            item.createTime = time.setTime(item.create_time);
            item.completeTime =
              item.status == 1 ? time.setTime(item.complete_time) : "----";
            item.is_status = item.status == 1 ? "已完成" : "进行中";
            item.index = c_index + 1;
          });
        }
      });
    },
    // 判断页面展示
    jude() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      sendList(data).then(res => {
        if (res.code == 200) {
          this.judeStatus = res.data.total != 0 ? true : false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.shell {
  width: 100%;
  height: 100%;
  // 数据列表展示
  .dataList {
    width: 100%;
    .tops {
      padding: 40px 20px 0;
      .topTile {
        font-size: 16px;
      }
      .secondTitle {
        color: #979ba0;
        font-size: 14px;
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        border-bottom: 1px solid #eee;
      }
    }
    .list {
      padding-top: 16px;
    }
  }
  .descPage {
    height: 200px;
    background: #fff;
    border-radius: 4px;
    margin-top: 30px;
    padding: 40px 40px 45px;
  }

  .descPage .functionDesc {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .descPage .functionDesc .imgBox {
    width: 540px;
    height: 514px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .ordinaryListPage .functionDesc .imgBox {
    background-image: url("../../../../../../../../public/img/push.png");
  }

  .regularListPage .functionDesc .imgBox {
    background-image: url(/public/img/push.png);
  }

  .descPage .functionDesc .descBox {
    padding-left: 76px;
    color: #7c8290;
    line-height: 36px;
    font-size: 14px;
  }

  .descPage .functionDesc .descBox .title {
    margin-top: 63px;
    font-size: 24px;
    color: #4c566c;
  }

  .descPage .functionDesc .descBox .smTitle {
    margin: 30px 0 16px;
    font-size: 18px;
    color: #7c8290;
  }

  .descPage .functionDesc .createRightNow {
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      from(#1fdeda),
      to(#2edf65)
    );
    background: linear-gradient(90deg, #1fdeda, #2edf65);
    -webkit-box-shadow: 0 4px 14px 0 rgba(0, 184, 181, 0.3);
    box-shadow: 0 4px 14px 0 rgba(0, 184, 181, 0.3);
    border-radius: 20px;
    color: #fff;
    cursor: pointer;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    text-align: center;
    margin: 103px auto 0;
  }

  .descPage.regularListPage .functionDesc .createRightNow {
    margin: 67px auto 0;
  }

  .descPage .functionDesc .createRightNow:hover {
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      from(#00d2d5),
      to(#00d86b)
    );
    background: linear-gradient(90deg, #00d2d5, #00d86b);
  }
}
</style>
